import round from 'lodash/round'
import { distanceBetweenCoordinates } from '~/lib/geoUtils'
import { RestaurantAreas, RestaurantLiteWithDistanceList } from '~/lib/interfaces/restaurant'
import { Coords } from '~/lib/models/geolocation'

export const useRestaurantsMOP = () => {
  const countryCode = useCountry()
  const authStore = useAuthStore()
  const appStore = useAppStore()
  const { restaurantServiceRef } = useStoreService()

  const restaurantService = restaurantServiceRef()
  const KEY = `${countryCode}-restaurants-mop`

  const isSSR = computed(() => import.meta.server)

  const getSessionItem = <T>(key: string): T => {
    if (isSSR.value) return [] as T
    const item = sessionStorage.getItem(key)
    if (!item) return [] as T
    return JSON.parse(item)
  }

  const setSessionItem = <T>(key: string, data: T) => {
    if (isSSR.value) return
    return sessionStorage.setItem(key, JSON.stringify(data))
  }

  const list = computed(() => {
    return getSessionItem<RestaurantLiteWithDistanceList>(KEY)
  })

  const fetchListRestaurants = async () => {
    let restaurantsList: RestaurantLiteWithDistanceList = []
    if (isSSR.value) return
    if (appStore.isEcommerceDisabled) {
      setSessionItem<RestaurantLiteWithDistanceList>(KEY, restaurantsList)
      return
    }

    if (list.value?.length) return

    try {
      restaurantsList = await restaurantService.getStoreListRestaurant({
        area: RestaurantAreas.MOP,
        countryCode,
      })

      restaurantsList = restaurantsList.map(res => ({
        ...res,
        ecommerce: true,
        isFavorite: isFavoriteRestaurant({
          countryCode,
          favoriteRestaurantsMetadata: authStore?.userMetadata?.favoriteRestaurants,
          restaurantCode: res.code,
        }),
      }))
      setSessionItem<RestaurantLiteWithDistanceList>(KEY, restaurantsList)
    } catch (error) {
      //
      setSessionItem<RestaurantLiteWithDistanceList>(KEY, restaurantsList)
    }
  }

  const updateListByCoords = (coords: Coords) => {
    let restaurantsList = getSessionItem<RestaurantLiteWithDistanceList>(KEY)
    if (!restaurantsList?.length) return
    restaurantsList = restaurantsList.map(res => {
      return {
        ...res,
        distance: round(
          distanceBetweenCoordinates(
            coords.lat,
            coords.lng,
            res.coordinates.latitude,
            res.coordinates.longitude,
            'K'
          ),
          2
        ),
      }
    })
    setSessionItem<RestaurantLiteWithDistanceList>(KEY, restaurantsList)
  }
  // const updateList = async () => {}

  return {
    list,
    fetchListRestaurants,
    updateListByCoords,
  }
}
